module.exports = __webpack_public_path__ + "sound/related_order_traded.wav";


//////////////////
// WEBPACK FOOTER
// ./source/assets/sound/related_order_traded.wav
// module id = 1041
// module chunks = 0